import { ROUTES, ROLES, FUNCTIONAL_ROLES } from 'config/constants';
import {
  getPostLoginRouteForUser,
  isPlatformAdminRoute,
  isPlatformAdministrator,
} from 'utils/platformAdmin';

// Centralized map of roles to forbidden route prefixes
// Extend this map as new rules arise
export const ROUTES_BLACKLIST_MAP = {
  [FUNCTIONAL_ROLES.SPONSOR_PERSONNEL]: [
    ROUTES.SPONSORS,
    ROUTES.MY_SPONSORS,
    ROUTES.SPONSOR_PROFILE_REQUESTS,
    ROUTES.ORGANIZATION_SETTINGS,
  ],
  [FUNCTIONAL_ROLES.RESEARCH_SITE_PERSONNEL]: [ROUTES.ORGANIZATION_SETTINGS],
  [FUNCTIONAL_ROLES.PERSONNEL_INDIVIDUAL]: [
    ROUTES.APPLICATIONS_BY_RESEARCH_SITE,
    ROUTES.APPLICATIONS_BY_SPONSOR,
    ROUTES.ALL_PATIENTS,
    ROUTES.PATIENTS_ON_STUDIES,
    ROUTES.PATIENT,
    ROUTES.PATIENT_NEW,
    ROUTES.ORGANIZATION_SETTINGS,
  ],
};

function getFunctionalRole(groups) {
  if (groups.includes(ROLES.SPONSOR)) {
    return FUNCTIONAL_ROLES.SPONSOR_ADMIN;
  }
  if (groups.includes(ROLES.RESEARCH_SITE)) {
    return FUNCTIONAL_ROLES.RESEARCH_SITE_ADMIN;
  }
  if (groups.includes(ROLES.RESEARCH_SITE_PERSONNEL)) {
    return FUNCTIONAL_ROLES.RESEARCH_SITE_PERSONNEL;
  }
  if (groups.includes(ROLES.SPONSOR_PERSONNEL)) {
    return FUNCTIONAL_ROLES.SPONSOR_PERSONNEL;
  }
  if (
    groups.includes(ROLES.PERSONNEL) &&
    (!groups.includes(ROLES.RESEARCH_SITE_PERSONNEL) ||
      !groups.includes(ROLES.SPONSOR_PERSONNEL))
  ) {
    return FUNCTIONAL_ROLES.PERSONNEL_INDIVIDUAL;
  }
}

export function isPathForbiddenForGroups(pathname = '', groups = []) {
  if (!Array.isArray(groups) || groups.length === 0) return false;

  if (isPlatformAdministrator(groups)) {
    return !isPlatformAdminRoute(pathname);
  }

  const functionalRole = getFunctionalRole(groups);

  if (!functionalRole) {
    return false;
  }

  const normalizedPath = String(pathname);

  const isPrefixMatch = (prefix) => {
    if (!prefix) return false;
    return (
      normalizedPath === prefix ||
      normalizedPath.startsWith(`${prefix}/`) ||
      normalizedPath.startsWith(`${prefix}?`)
    );
  };

  const forbiddenPrefixes = ROUTES_BLACKLIST_MAP[functionalRole];

  if (!forbiddenPrefixes || forbiddenPrefixes.length === 0) {
    return false;
  }

  return !!forbiddenPrefixes.some((p) => isPrefixMatch(p));
}

// Returns a redirect target for a forbidden path; currently always home
export function getRedirectTargetForForbiddenPath(pathname, groups = []) {
  if (isPlatformAdministrator(groups)) {
    return getPostLoginRouteForUser(groups);
  }

  return ROUTES.HOME_PAGE;
}
